import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-73fe9872"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "h-full font-inter"
}
const _hoisted_2 = { class: "flex flex-col h-full" }
const _hoisted_3 = { class: "p-4 border-b flex items-center justify-between sticky top-0 bg-white z-10" }
const _hoisted_4 = {
  viewBox: "0 0 24 24",
  role: "presentation",
  style: {"width":"1.5rem","height":"1.5rem"}
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z",
  fill: "currentColor"
}, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "font-bold text-lg" }, "Carrinho de Compras", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-10" }, null, -1))
const _hoisted_9 = { class: "flex-1 overflow-y-auto p-4 flex flex-col gap-4 pb-40" }
const _hoisted_10 = {
  key: 0,
  class: "flex flex-col items-center justify-center py-20 opacity-30"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "64",
  height: "64",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "8",
    cy: "21",
    r: "1"
  }),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "19",
    cy: "21",
    r: "1"
  }),
  /*#__PURE__*/_createElementVNode("path", { d: "M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.56-6.43h-13.78" })
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-4 font-bold" }, "Carrinho vazio", -1))
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = { class: "p-4 flex gap-4" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "flex-1" }
const _hoisted_17 = { class: "flex justify-between items-start" }
const _hoisted_18 = { class: "font-bold text-gray-800 leading-tight" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "18",
  height: "18",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M3 6h18" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" })
], -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = { class: "text-success font-bold text-sm mt-1" }
const _hoisted_23 = { class: "flex items-center justify-between mt-3" }
const _hoisted_24 = { class: "flex gap-4 items-center bg-gray-100 p-1 px-3 rounded-full border" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.5"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M5 12h14" })
], -1))
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = { class: "font-bold text-xs" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.5"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M12 5v14M5 12h14" })
], -1))
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = ["onClick"]
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "m6 9 6 6 6-6" }, null, -1))
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = {
  key: 0,
  class: "px-4 pb-4 bg-gray-50/50 border-t"
}
const _hoisted_36 = { class: "mt-3 flex flex-col gap-2" }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { class: "text-[9px] uppercase font-bold text-gray-400 mb-1 border-b pb-1" }
const _hoisted_39 = { class: "flex flex-wrap gap-2" }
const _hoisted_40 = { class: "mt-3 flex flex-col gap-2" }
const _hoisted_41 = { key: 0 }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-[9px] uppercase font-bold text-gray-400 mb-1 border-b pb-1" }, "Adicionais", -1))
const _hoisted_43 = { class: "flex flex-col gap-1" }
const _hoisted_44 = { class: "text-gray-600 font-medium" }
const _hoisted_45 = { class: "text-gray-400 font-bold" }
const _hoisted_46 = {
  key: 0,
  class: "p-6 bg-white border-t rounded-t-3xl box-shadow sticky bottom-0 z-20"
}
const _hoisted_47 = { class: "flex flex-col gap-3 mb-6" }
const _hoisted_48 = { class: "flex justify-between items-center text-gray-500 font-medium" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Subtotal", -1))
const _hoisted_50 = { class: "flex justify-between items-center text-gray-800 font-bold text-xl" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Total", -1))
const _hoisted_52 = { class: "text-primary" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.5"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "m9 18 6-6-6-6" })
], -1))
const _hoisted_54 = {
  key: 1,
  class: "h-full font-inter p-6 flex flex-col gap-6 enter-content-animation"
}
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.5"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "m15 18-6-6 6-6" })
], -1))
const _hoisted_56 = { class: "flex flex-col gap-6" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h2", { class: "text-2xl font-bold mb-1" }, "Finalização"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-500" }, "Selecione o cliente e adicione observações se necessário.")
], -1))
const _hoisted_58 = { class: "flex flex-col gap-2" }
const _hoisted_59 = { class: "flex items-center justify-between" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-bold text-sm uppercase tracking-wider text-gray-400" }, "Selecionar Cliente", -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: null }, "Selecione uma comanda/mesa", -1))
const _hoisted_62 = ["value"]
const _hoisted_63 = { class: "flex flex-col gap-2" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-bold text-sm uppercase tracking-wider text-gray-400" }, "Observações do Pedido", -1))
const _hoisted_65 = { class: "flex flex-col gap-2" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-bold text-sm uppercase tracking-wider text-gray-400" }, "Desconto (opcional)", -1))
const _hoisted_67 = { class: "mt-4 p-6 bg-zinc-900 rounded-3xl text-white shadow-xl" }
const _hoisted_68 = { class: "flex justify-between items-center mb-6" }
const _hoisted_69 = { class: "flex flex-col w-full" }
const _hoisted_70 = { class: "flex justify-between mb-2" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-xs opacity-50 uppercase font-bold tracking-widest" }, "Subtotal", -1))
const _hoisted_72 = { class: "text-sm opacity-50" }
const _hoisted_73 = {
  key: 0,
  class: "flex justify-between mb-2"
}
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-xs opacity-50 uppercase font-bold tracking-widest" }, "Desconto", -1))
const _hoisted_75 = { class: "text-sm text-red-400" }
const _hoisted_76 = { class: "flex justify-between" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-xs opacity-50 uppercase font-bold tracking-widest" }, "Total", -1))
const _hoisted_78 = { class: "text-3xl font-bold text-success" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-12 w-12 bg-white/10 rounded-2xl flex items-center justify-center" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M12 2v20" }),
    /*#__PURE__*/_createElementVNode("path", { d: "M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" })
  ])
], -1))
const _hoisted_80 = ["disabled"]
const _hoisted_81 = { key: 0 }
const _hoisted_82 = { key: 1 }
const _hoisted_83 = {
  key: 2,
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "3"
}
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "m12 5 7 7-7 7" }, null, -1))
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M5 12h14" }, null, -1))
const _hoisted_86 = [
  _hoisted_84,
  _hoisted_85
]

import { ref, watch, computed, onMounted } from 'vue'
import MyModal from '@/components/modal/MyModal.vue';
import { cart, commands, selectedCommand, apiBaseUrl, organizationSettings } from '@/global/state/GlobalState';
import { useToast } from "vue-toastification";
import axiosClient from '@/api/axios';


export default /*#__PURE__*/_defineComponent({
  __name: 'CartComponent',
  props: {
    isOpen: { type: Boolean },
    setIsOpen: { type: Function }
  },
  setup(__props: any) {

const props = __props

const currentPage = ref<number>(1)
const notes = ref<string>('')
const discount = ref<number>(0)
const selectedTabId = ref<number | null>(null)
const isPlacingOrder = ref<boolean>(false)
const toast = useToast()

// Watchers
watch(() => cart.value, (newCart: any) => {
    localStorage.setItem('cart', JSON.stringify(newCart))
}, { deep: true })

// Initialize selected tab from global state
onMounted(() => {
    if (selectedCommand.value?.id) {
        selectedTabId.value = selectedCommand.value.id
    }
})

watch(() => selectedCommand.value, (newVal) => {
    if (newVal?.id) {
        selectedTabId.value = newVal.id
    }
})

// Computed
const flattenedTabs = computed(() => {
    const allTabs: any[] = []
    Object.values(commands.value).forEach((tabList: any) => {
        if (Array.isArray(tabList)) {
            allTabs.push(...tabList)
        }
    })
    return allTabs
})

const totalPrice = computed<number>(() => {
    return cart.value.reduce((acc: number, item: any) => acc + (item.unitPrice * item.quantity), 0)
})

// Item helper methods
function hasExtras(product: any) {
    const hasVariants = Object.values(product.selectedVariants || {}).some((ids: any) => ids.length > 0)
    const hasAddOns = Object.keys(product.selectedAddOns || {}).length > 0
    return hasVariants || hasAddOns
}

function getVariantGroupName(product: any, groupId: number) {
    return product.variantGroups?.find((g: any) => g.id === groupId)?.name || 'Opção'
}

function getVariantName(product: any, groupId: number, variantId: number) {
    const group = product.variantGroups?.find((g: any) => g.id === groupId)
    return group?.variants?.find((v: any) => v.id === variantId)?.name || ''
}

function getAddOnName(product: any, addonId: number) {
    return product.addOnGroups?.flatMap((g: any) => g.addOns).find((a: any) => a.id === addonId)?.name || ''
}

function getAddOnPrice(product: any, addonId: number) {
    return product.addOnGroups?.flatMap((g: any) => g.addOns).find((a: any) => a.id === addonId)?.price || 0
}

async function placeOrder() {
    if (!selectedTabId.value || cart.value.length === 0) return

    isPlacingOrder.value = true
    
    // Transform cart to the API format
    const productsPayload = cart.value.map((item: any) => {
        const productData: any = {
            id: item.id,
            quantity: item.quantity,
        }

        // Include item notes if present
        if (item.notes) {
            productData.notes = item.notes
        }

        // Flatten variants
        const variants: any[] = []
        Object.values(item.selectedVariants || {}).forEach((ids: any) => {
            ids.forEach((vId: number) => variants.push({ id: vId, quantity: item.quantity }))
        })
        if (variants.length > 0) productData.variants = variants

        // Flatten addons
        const addons: any[] = []
        Object.entries(item.selectedAddOns || {}).forEach(([id, qty]: [string, any]) => {
            addons.push({ id: parseInt(id), quantity: qty * item.quantity })
        })
        if (addons.length > 0) productData.addOns = addons

        return productData
    })

    const payload = {
        tabId: selectedTabId.value,
        notes: notes.value,
        discount: discount.value > 0 ? discount.value : undefined,
        type: 'waiter', // Waiter app usually creates waiter-type orders
        paymentMethod: 'cash', // Default or handled later? API needs one.
        products: productsPayload,
    }

    try {
        await axiosClient.post('/orders', payload)
        toast.success('Pedido confirmado com sucesso!')
        
        // Clean cart
        cart.value = []
        localStorage.removeItem('cart')
        notes.value = ''
        discount.value = 0
        currentPage.value = 1
        props.setIsOpen(false)
    } catch (error: any) {
        const message = error.response?.data?.errors?.[0]?.message || error.response?.data?.message || "Erro ao processar pedido"
        toast.error(message)
    } finally {
        isPlacingOrder.value = false
    }
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(MyModal, {
    zIndex: 100,
    isOpen: _ctx.isOpen,
    toggleModal: (v) => _ctx.setIsOpen(v)
  }, {
    default: _withCtx(() => [
      (currentPage.value == 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("button", {
                  class: "transition duration-200 hover:text-primary p-2",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setIsOpen(false)))
                }, [
                  (_openBlock(), _createElementBlock("svg", _hoisted_4, _hoisted_6))
                ]),
                _hoisted_7,
                _hoisted_8
              ]),
              _createElementVNode("div", _hoisted_9, [
                (_unref(cart).length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_13))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cart), (product, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: product.cartId,
                    class: "bg-white border rounded-2xl overflow-hidden box-shadow transition hover:border-primary"
                  }, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("img", {
                        class: "h-20 w-20 rounded-xl object-cover border",
                        src: product.media?.length ? (_unref(apiBaseUrl) + '/storage/' + product.media[0].path) : '/assets/no-image.png',
                        onError: _cache[1] || (_cache[1] = ($event: any) => (($event.target as HTMLImageElement).src = '/assets/no-image.png'))
                      }, null, 40, _hoisted_15),
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("h5", _hoisted_18, _toDisplayString(product.name), 1),
                          _createElementVNode("button", {
                            onClick: ($event: any) => (_unref(cart).splice(index, 1)),
                            class: "text-gray-400 hover:text-red-500 transition"
                          }, _hoisted_21, 8, _hoisted_19)
                        ]),
                        _createElementVNode("p", _hoisted_22, _toDisplayString(product.unitPrice.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL'})), 1),
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("button", {
                              onClick: ($event: any) => (product.quantity > 1 ? product.quantity-- : _unref(cart).splice(index, 1)),
                              class: "text-gray-500 hover:text-primary transition"
                            }, _hoisted_27, 8, _hoisted_25),
                            _createElementVNode("span", _hoisted_28, _toDisplayString(product.quantity), 1),
                            _createElementVNode("button", {
                              onClick: ($event: any) => (product.quantity++),
                              class: "text-gray-500 hover:text-primary transition"
                            }, _hoisted_31, 8, _hoisted_29)
                          ]),
                          (hasExtras(product))
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                onClick: ($event: any) => (product.seeMore = !product.seeMore),
                                class: "text-[10px] font-bold uppercase text-gray-400 hover:text-primary flex items-center gap-1"
                              }, [
                                _createTextVNode(_toDisplayString(product.seeMore ? 'Ocultar' : 'Detalhes') + " ", 1),
                                (_openBlock(), _createElementBlock("svg", {
                                  width: "12",
                                  height: "12",
                                  viewBox: "0 0 24 24",
                                  fill: "none",
                                  stroke: "currentColor",
                                  "stroke-width": "3",
                                  class: _normalizeClass([product.seeMore ? 'rotate-180' : '', "transition"])
                                }, _hoisted_34, 2))
                              ], 8, _hoisted_32))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    (product.seeMore)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                          _createElementVNode("div", _hoisted_36, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(product.selectedVariants, (variantIds, groupId) => {
                              return (_openBlock(), _createElementBlock("div", { key: groupId }, [
                                (variantIds.length > 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                      _createElementVNode("p", _hoisted_38, _toDisplayString(getVariantGroupName(product, parseInt(groupId as string))), 1),
                                      _createElementVNode("div", _hoisted_39, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(variantIds, (vId) => {
                                          return (_openBlock(), _createElementBlock("span", {
                                            key: vId,
                                            class: "text-[11px] bg-white border px-2 py-0.5 rounded-lg text-gray-600 font-medium"
                                          }, _toDisplayString(getVariantName(product, parseInt(groupId as string), vId)), 1))
                                        }), 128))
                                      ])
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            }), 128))
                          ]),
                          _createElementVNode("div", _hoisted_40, [
                            (Object.keys(product.selectedAddOns).length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                  _hoisted_42,
                                  _createElementVNode("div", _hoisted_43, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(product.selectedAddOns, (qty, addonId) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: addonId,
                                        class: "flex justify-between items-center text-[11px]"
                                      }, [
                                        _createElementVNode("span", _hoisted_44, _toDisplayString(qty) + "x " + _toDisplayString(getAddOnName(product, parseInt(addonId as string))), 1),
                                        _createElementVNode("span", _hoisted_45, "+" + _toDisplayString((getAddOnPrice(product, parseInt(addonId as string)) * qty).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL'})), 1)
                                      ]))
                                    }), 128))
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]),
              (_unref(cart).length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                    _createElementVNode("div", _hoisted_47, [
                      _createElementVNode("div", _hoisted_48, [
                        _hoisted_49,
                        _createElementVNode("span", null, _toDisplayString(totalPrice.value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL'})), 1)
                      ]),
                      _createElementVNode("div", _hoisted_50, [
                        _hoisted_51,
                        _createElementVNode("span", _hoisted_52, _toDisplayString(totalPrice.value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL'})), 1)
                      ])
                    ]),
                    _createElementVNode("button", {
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (currentPage.value = 2)),
                      class: "w-full bg-zinc-900 text-white p-4 rounded-2xl font-bold flex items-center justify-center gap-2 hover:bg-zinc-800 transition shadow-lg"
                    }, [
                      _createTextVNode(" Próximo Passo "),
                      _hoisted_53
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_54, [
            _createElementVNode("button", {
              class: "flex items-center gap-2 text-primary font-bold hover:gap-3 transition transition-all duration-200",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (currentPage.value = 1))
            }, [
              _hoisted_55,
              _createTextVNode(" Voltar ")
            ]),
            _createElementVNode("div", _hoisted_56, [
              _hoisted_57,
              _createElementVNode("div", _hoisted_58, [
                _createElementVNode("div", _hoisted_59, [
                  _hoisted_60,
                  _createVNode(_component_RouterLink, {
                    to: {name:'tables'},
                    class: "text-xs text-primary font-bold hover:underline",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setIsOpen(false)))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Nova Comanda")
                    ]),
                    _: 1
                  })
                ]),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((selectedTabId).value = $event)),
                  class: "w-full p-4 bg-gray-50 border rounded-2xl focus:ring-2 focus:ring-primary/20 outline-none font-medium"
                }, [
                  _hoisted_61,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(flattenedTabs.value, (tab) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: tab.id,
                      value: tab.id
                    }, " Mesa " + _toDisplayString(tab.number) + " - " + _toDisplayString(tab.name || 'Anônimo'), 9, _hoisted_62))
                  }), 128))
                ], 512), [
                  [_vModelSelect, selectedTabId.value]
                ])
              ]),
              _createElementVNode("div", _hoisted_63, [
                _hoisted_64,
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((notes).value = $event)),
                  rows: "4",
                  placeholder: "Ex: Tirar cebola, ponto da carne mal passado...",
                  class: "w-full p-4 bg-gray-50 border rounded-2xl focus:ring-2 focus:ring-primary/20 outline-none text-sm"
                }, null, 512), [
                  [_vModelText, notes.value]
                ])
              ]),
              _createElementVNode("div", _hoisted_65, [
                _hoisted_66,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((discount).value = $event)),
                  type: "number",
                  min: "0",
                  step: "0.01",
                  placeholder: "R$ 0,00",
                  class: "w-full p-4 bg-gray-50 border rounded-2xl focus:ring-2 focus:ring-primary/20 outline-none text-sm"
                }, null, 512), [
                  [
                    _vModelText,
                    discount.value,
                    void 0,
                    { number: true }
                  ]
                ])
              ]),
              _createElementVNode("div", _hoisted_67, [
                _createElementVNode("div", _hoisted_68, [
                  _createElementVNode("div", _hoisted_69, [
                    _createElementVNode("div", _hoisted_70, [
                      _hoisted_71,
                      _createElementVNode("span", _hoisted_72, _toDisplayString(totalPrice.value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })), 1)
                    ]),
                    (discount.value > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                          _hoisted_74,
                          _createElementVNode("span", _hoisted_75, "-" + _toDisplayString(discount.value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_76, [
                      _hoisted_77,
                      _createElementVNode("span", _hoisted_78, _toDisplayString((totalPrice.value - discount.value).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })), 1)
                    ])
                  ]),
                  _hoisted_79
                ]),
                _createElementVNode("button", {
                  disabled: !selectedTabId.value || isPlacingOrder.value,
                  onClick: placeOrder,
                  class: "w-full p-5 bg-primary text-white rounded-2xl font-bold hover:bg-opacity-90 transition disabled:opacity-20 flex items-center justify-center gap-3"
                }, [
                  (!isPlacingOrder.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_81, "Confirmar Pedido"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_82, "Enviando...")),
                  (!isPlacingOrder.value)
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_83, _hoisted_86))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_80)
              ])
            ])
          ]))
    ]),
    _: 1
  }, 8, ["isOpen", "toggleModal"]))
}
}

})